import React from 'react';
import propTypes from 'prop-types';
import {default as Checkbox} from '@sinclair-digital/sbg-storyline-components/src/components/forms/Checkbox';
import BulkEditTableRow from './BulkEditTableRow';
import classes from './BulkEditTable.scss';

const BulkEditTable = props => {
    const {
        allSelected,
        toggleSelectAll,
        onItemSelect,
        results,
    } = props;

    return (
        <table className={classes.container}>
            <thead>
                <tr>
                    <td>UUID</td>
                    <td>STATUS</td>
                    <td>TYPE</td>
                    <td>BYLINE</td>
                    <td>TITLE</td>
                    <td>
                        <Checkbox checked={allSelected} onChange={toggleSelectAll} />
                    </td>
                </tr>
            </thead>
            <tbody>
                {results.map((result, index) => (
                    <BulkEditTableRow
                        key={result.uuid}
                        result={result}
                        resultsIndex={index}
                        onItemSelect={onItemSelect}
                    />
                ))}
            </tbody>
        </table>
    );
};

BulkEditTable.propTypes = {
    allSelected: propTypes.bool,
    toggleSelectAll: propTypes.func,
    onItemSelect: propTypes.func,
    results: propTypes.arrayOf(propTypes.object),
};

export default BulkEditTable;
